import { useQueryParams } from "lib/hooks/useQueryParams";
import { useFetch } from "lib/useFetch";
import { createBody } from "pages/events/api/createBody";
import { tryParseEvents } from "pages/events/api/tryParseEvents";

const EVENTS_URL = "/research/japi/events/filter?sortBy=startDateTime&sortOrder=desc";

export default function useEvents(pastEventDate = "1month", hasQueryParams = true) {
  const queryParams = useQueryParams();
  const finalQueryParams = hasQueryParams ? queryParams : {};
  const reqBody = createBody(finalQueryParams, pastEventDate);
  const [data, isLoading, error] = useFetch(EVENTS_URL, reqBody, "POST");
  const [futureEvents, archivedEvents] = tryParseEvents(data, queryParams);
  const carouselEvents = futureEvents.slice(0, 7);

  return {
    isLoading,
    error,
    futureEvents,
    archivedEvents,
    carouselEvents,
  };
}
